module.exports = __webpack_public_path__ + "static/media/fly0024.8347a65f.webp";